import { lazy, Suspense, useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import HeroSection from './components/HeroSection/HeroSection';
import TrustSection from './components/TrustSection/TrustSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import IndustriesSection from './components/IndustriesSection/IndustriesSection';
import ProcessSection from './components/ProcessSection/ProcessSection';
import WhySection from './components/WhySection/WhySection';
import QuickStartSection from './components/QuickStartSection/QuickStartSection';
import DevSection from './components/DevSection/DevSection';
import PartnerSection from './components/PartnerSection/PartnerSection';
import ContactSection from './components/ContactSection/ContactSection';
import FAQSection from './components/FAQSection/FAQSection';
import './styles/global.css';

function ScrollToTop() {
  const { hash, key } = useLocation();
  useLayoutEffect(() => {
    if (!hash) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [key]);
  return null;
}

const TermsPage     = lazy(() => import('./pages/legal/TermsPage'));
const PrivacyPage   = lazy(() => import('./pages/legal/PrivacyPage'));
const RefundPage    = lazy(() => import('./pages/legal/RefundPage'));
const GrievancePage = lazy(() => import('./pages/legal/GrievancePage'));
const AMLPage       = lazy(() => import('./pages/legal/AMLPage'));
const PayoutPage       = lazy(() => import('./pages/PayoutPage'));
const IndustriesPage   = lazy(() => import('./pages/IndustriesPage'));
const LendingPage      = lazy(() => import('./pages/LendingPage'));
const InsurancePage    = lazy(() => import('./pages/InsurancePage'));
const EcommercePage    = lazy(() => import('./pages/EcommercePage'));
const LogisticsPage    = lazy(() => import('./pages/LogisticsPage'));
const MediaPage        = lazy(() => import('./pages/MediaPage'));
const EnterprisePage   = lazy(() => import('./pages/EnterprisePage'));
const AboutPage        = lazy(() => import('./pages/AboutPage'));
const FAQPage          = lazy(() => import('./pages/FAQPage'));
const BlogPage         = lazy(() => import('./pages/BlogPage'));
const ArticlePage      = lazy(() => import('./pages/ArticlePage'));
const ContactPage      = lazy(() => import('./pages/ContactPage'));
const PartnerPage      = lazy(() => import('./pages/PartnerPage'));

function LandingPage() {
  return (
    <>
      <HeroSection />
      <TrustSection />
      <FeaturesSection />
      <IndustriesSection />
      <ProcessSection />
      <WhySection />
      <QuickStartSection />
      <DevSection />
      <PartnerSection />
      <ContactSection />
      <FAQSection />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/legal/terms-of-use"            element={<TermsPage />} />
          <Route path="/legal/privacy-policy"         element={<PrivacyPage />} />
          <Route path="/legal/refund-and-cancellations" element={<RefundPage />} />
          <Route path="/legal/grievance-redressal"    element={<GrievancePage />} />
          <Route path="/legal/aml-kyc-policy" element={<AMLPage />} />
          <Route path="/payout"             element={<PayoutPage />} />
          <Route path="/industries"         element={<IndustriesPage />} />
          <Route path="/industries/lending"   element={<LendingPage />} />
          <Route path="/industries/insurance"  element={<InsurancePage />} />
          <Route path="/industries/ecommerce"  element={<EcommercePage />} />
          <Route path="/industries/logistics" element={<LogisticsPage />} />
          <Route path="/industries/media"       element={<MediaPage />} />
          <Route path="/industries/enterprise" element={<EnterprisePage />} />
          <Route path="/about"   element={<AboutPage />} />
          <Route path="/faq"     element={<FAQPage />} />
          <Route path="/blog"    element={<BlogPage />} />
          <Route path="/blog/all-articles" element={<ArticlePage />} />
          <Route path="/contact"  element={<ContactPage />} />
          <Route path="/partner"  element={<PartnerPage />} />
        </Routes>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}
